import landingAttributesList from './actions/landingAttributesList';
import getLandingAttribute from './actions/getLandingAttribute';
import uploadLandingAttributes from './mutations/uploadLandingAttributes';
import getLandingAttributes from './getters/getLandingAttributes';

const actions = {
    landingAttributesList,
    getLandingAttribute
};

const mutations = {
    uploadLandingAttributes
};

const getters = {
    getLandingAttributes
};

export default { actions, mutations, getters };
